import React from 'react';
// components
import Divider from "@mui/material/Divider";
import { Button, Card, CardHeader, CardContent } from '@mui/material';
import Swal from 'sweetalert2';

import Page from '../../componentes/Page';
import Iconify from '../../componentes/Iconify';
import CONFIG from '../../CONFIG.json';
import { buildBody, isEmpty, getUniqueKey, workWithLocalStorage, compruebaForm } from '../../auxiliares/funciones';
import TrabajadorForm from './form/form';
import { getServicios } from '../../auxiliares/maestros';

// ----------------------------------------------------------------------
export default function TrabajadorAlta(props) {
    const usuario = workWithLocalStorage('get','usuario',null);
    const Form = {nombre:'',puesto:'',libranzas:'',jornada:0}
    const obligatorios = ['nombre','puesto'];

    const [trabajador, setTrabajador] = React.useState(Form);
    const [serviciosT, setServiciosT] = React.useState([]);
    const [servicios, setServicios] = React.useState([]);
    const [cargado, setCargado] = React.useState(false);
    const [id,setId] = React.useState(props.params.id ? props.params.id : '0');

    React.useEffect(() => {
        async function cargaInicial(){
            if(!cargado){
                setServicios(await getServicios(usuario.token));

                if(id !== '0'){
                    // eslint-disable-next-line
                    const bodyJson = JSON.stringify(buildBody(usuario.token,{ id:id }))
                    fetch(`${CONFIG.api}trabajador/detalle`,{
                                method: 'POST',
                                body: bodyJson,
                                headers: {'Content-Type': 'application/json'}
                        })
                        .then(res => res.json())
                        .then((result) => {
                        if (result.error === 0 && !isEmpty(result.data)) {
                            setTrabajador(result.data.trab);
                            setServiciosT(result.data.servicios);
                        }
                        props.showLoader(false);
                        setCargado(true);
                    })
                }else{
                    props.showLoader(false);
                    setCargado(true);
                }
            }
        }
        cargaInicial();
      // eslint-disable-next-line
      },[cargado]);

    const Grabar = () =>{
        const valido = compruebaForm(Form,trabajador,obligatorios);
        if(valido){
            // eslint-disable-next-line react/prop-types
            props.showLoader(true);
            const body = trabajador;
            const bodyJson = JSON.stringify(buildBody(usuario.token,body))
            fetch(`${CONFIG.api}trabajador/detalle`,{
                    method: 'PUT',
                    body: bodyJson,
                    headers: {'Content-Type': 'application/json'}
            })
            .then(res => res.json())
            .then((result) => {
                let msg ='Trabajador grabado!';
                if (result.error === 0) {
                    setId(result.data.id);
                    document.getElementById(`simple-tab-${props.index}`).getElementsByTagName( 'span' )[0].textContent = `Editar trabajador #${result.data.id} `;
                    setCargado(false);
                }else{
                    props.showLoader(false);
                    msg = result.errorMessage;
                }
                Swal.fire({
                title: msg,
                buttons: [{label: 'Ok'}]
                })
            })
        }else{
            Swal.fire({
                title: 'Revisa los campos con *',
                buttons: [{label: 'Ok'}]
            })
        }
    }

    const Nuevo = () =>{
        setTrabajador(Form);
        setId('0')
        document.getElementById(`simple-tab-${props.index}`).getElementsByTagName( 'span' )[0].textContent = 'Alta Trabajador ';
    }

    const actualizaCampo = (input) =>{
        const nombre = input.target.name
        const valor = input.target.value
        trabajador[nombre] = valor
        setTrabajador(trabajador);
    }

    const Activar = () =>{
        // eslint-disable-next-line react/prop-types
        props.showLoader(true);
        const body = {
          tabla: "trabajador",
          activo: 1,
          id: trabajador.id
        }
        const bodyJson = JSON.stringify(buildBody(usuario.token,body))
        fetch(`${CONFIG.api}master/activo`,{
                  method: 'PUT',
                  body: bodyJson,
                  headers: {'Content-Type': 'application/json'}
          })
          .then(res => res.json())
          .then((result) => {
            let msg ='Trabajador activado!';
            if (result.error === 0) {
                setCargado(false);
            }else{
              props.showLoader(false);
              msg = result.errorMessage;
            }
            Swal.fire({
              title: msg,
              buttons: [{label: 'Ok'}]
            })
        })
    }

    const Borrar = () =>{
        // eslint-disable-next-line react/prop-types
        props.showLoader(true);
        const body = {
            tabla: "trabajador",
            activo: 0,
            id: trabajador.id
        }
        const bodyJson = JSON.stringify(buildBody(usuario.token,body))
        fetch(`${CONFIG.api}master/activo`,{
                    method: 'PUT',
                    body: bodyJson,
                    headers: {'Content-Type': 'application/json'}
            })
            .then(res => res.json())
            .then((result) => {
                let msg ='Trabajador desactivado!';
                if (result.error === 0) {
                    setCargado(false);
                }else{
                    props.showLoader(false);
                    msg = result.errorMessage;
                }
                props.showLoader(false);
                Swal.fire({
                title: msg,
                buttons: [{label: 'Ok'}]
                })
        })
    }

    return (
        <Page title="Alta Trabajador" key={getUniqueKey()}>
            <Card  sx={{ maxWidth: '100% !important'}}>
                <CardHeader action={<>
                                    <Button variant="contained" color="success" sx={{ color: 'white', marginRight: '15px'}} to="#" startIcon={<Iconify icon="eva:plus-fill" />}
                                    onClick={()=>Grabar(null)}>
                                        Grabar
                                    </Button>
                                    <Button variant="contained" color="primary" sx={{ color: 'white', marginRight: '15px'}} to="#" startIcon={<Iconify icon="eva:edit-outline" />}
                                    onClick={()=>Nuevo()}>
                                        Nuevo
                                    </Button>
                                    {trabajador.id &&
                                    (trabajador.activo === 1 ?
                                    <Button variant="contained" color="error" sx={{ color: 'white'}} to="#" startIcon={<Iconify icon="eva:trash-2-outline" />}
                                    onClick={()=>Borrar()}>
                                        Borrar
                                    </Button>
                                    : <Button variant="contained" color="warning" sx={{ color: 'white'}} to="#" startIcon={<Iconify icon="eva:refresh-fill" />}
                                    onClick={()=>Activar()}>
                                        Activar
                                    </Button>)
                                    }
                                    </>}
                        title={id === '0' ? "Alta Trabajador" : `Editar Trabajador #${id}`}
                />
                <Divider style={{ margin: '15px'}} />
                <CardContent>
                    {cargado &&
                    <TrabajadorForm showLoader={props.showLoader} servicios={servicios} serviciosT={serviciosT} trabajador={trabajador} actualizaCampo={actualizaCampo}/>
                    }
                </CardContent>
            </Card>
        </Page>
    );
}
